import imgSection1 from "../img/section1_img.jpg";
import { FaRocket, FaArrowRight, FaCheckCircle } from "react-icons/fa";

export default function Section1() {
  return (
    <div className="relative bg-white overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-50 to-white"></div>
        <div className="absolute top-0 right-0 w-48 h-48 sm:w-72 sm:h-72 bg-purple-50 rounded-full mix-blend-multiply filter blur-3xl opacity-40"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 sm:w-72 sm:h-72 bg-purple-50 rounded-full mix-blend-multiply filter blur-3xl opacity-40"></div>
      </div>
      
      <div className="relative z-10 mx-3">
        <div id="qui-suis-je" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Hero Section */}
          <div className="pt-12 pb-8 sm:pt-16 sm:pb-12 lg:pt-24 lg:pb-16">
            <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
              
              {/* Left Content */}
              <div className="text-center lg:text-left lg:pr-8">
                <div className="mb-4 sm:mb-6 flex justify-center lg:justify-start">
                  <span className="inline-flex items-center px-3 py-1 rounded-full text-xs sm:text-sm font-medium bg-blue-50 text-blue-700 border border-blue-200">
                    <FaRocket className="mr-2" size={12} />
                    Solutions Digitales
                  </span>
                </div>
                
                <h1 className="mx-auto text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-4 sm:mb-6">
                  Améliorez&nbsp;
                  <span className="inline text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-purple-700">
                    votre entreprise
                  </span>
                  &nbsp;grâce au&nbsp;
                  <span className="inline text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-purple-700">
                    numérique
                  </span>
                </h1>
                
                <p className="text-base sm:text-lg lg:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed max-w-lg mx-auto lg:mx-0">
                  Solutions sur mesure pour les entreprises ambitieuses qui souhaitent accélérer leur croissance grâce au numérique.
                </p>

                {/* Key Points */}
                <div className="space-y-2 sm:space-y-3 mb-6 sm:mb-8 text-left">
                  <div className="flex items-center justify-start">
                    <FaCheckCircle className="text-green-500 mr-3 flex-shrink-0" size={16} />
                    <span className="text-sm sm:text-base text-gray-700">Développement personnalisé selon vos besoins</span>
                  </div>
                  <div className="flex items-center justify-start">
                    <FaCheckCircle className="text-green-500 mr-3 flex-shrink-0" size={16} />
                    <span className="text-sm sm:text-base text-gray-700">Accompagnement complet de A à Z</span>
                  </div>
                  <div className="flex items-center justify-start">
                    <FaCheckCircle className="text-green-500 mr-3 flex-shrink-0" size={16} />
                    <span className="text-sm sm:text-base text-gray-700">Optimisation et automatisation</span>
                  </div>
                </div>

                {/* CTA Buttons */}
                <div className="flex flex-col gap-3 sm:gap-4 max-w-sm mx-auto lg:mx-0 lg:max-w-none lg:flex-row">
                  <button onClick={() => window.location.href = "#Contact"} className="w-full lg:w-auto inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 text-sm sm:text-base font-semibold text-white bg-gradient-to-r from-purple-600 to-purple-700 rounded-xl hover:from-purple-700 hover:to-purple-800 transform hover:scale-105 transition duration-200 shadow-lg hover:shadow-xl">
                    Démarrer mon projet
                    <FaArrowRight className="ml-2" size={14} />
                  </button>
                  <button onClick={() => window.location.href = "#Projets"} className="w-full lg:w-auto inline-flex items-center justify-center px-6 sm:px-8 py-3 sm:py-4 text-sm sm:text-base font-semibold text-gray-700 bg-white border-2 border-gray-200 rounded-xl hover:border-gray-300 hover:bg-gray-50 transition duration-200">
                    Voir mes réalisations
                  </button>
                </div>
              </div>

              {/* Right Content - Image */}
              <div className="relative order-last lg:order-last mt-8 lg:mt-0">
                <div className="relative">
                  <img 
                    className="w-full h-64 sm:h-80 md:h-96 lg:h-[500px] object-cover rounded-2xl shadow-2xl" 
                    src={imgSection1} 
                    alt="Solutions numériques professionnelles" 
                  />
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  );
}